export const equipmentCategories = [
  {
    id: 'hydraulic-cylinders',
    title: 'Hydraulic Cylinders',
    summary: 'Cylinder repair and rebuilding for industrial hydraulic systems.',
    image: '/images/landing-img1.png',
  },
  {
    id: 'gearboxes',
    title: 'Gearboxes',
    summary: 'Repair support for industrial gearboxes and drive components.',
    image: '/images/landing-img2.png',
  },
  {
    id: 'mechanical-components',
    title: 'Mechanical Components',
    summary: 'Related components for gearbox and hydraulic repair work.',
    image: '/images/landing-img3.png',
  },
  {
    id: 'industrial-equipment',
    title: 'Industrial Equipment',
    summary: 'Repair support for industrial equipment across Canada.',
    image: '/images/landing-img4.png',
  },
];
